import { CognitoUser } from '@livecontrol/scheduler/model';

export const __typename = 'Users';

export const normalize = (record?: CognitoUser.Candidate): CognitoUser | undefined => {
  let user: CognitoUser | undefined;

  if (record) {
    user = CognitoUser.normalize(record);
  }

  return user;
};
